/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ReverseAccessEntry,
  ReverseAccessEntry$inboundSchema,
  ReverseAccessEntry$Outbound,
  ReverseAccessEntry$outboundSchema,
} from "./reverseaccessentry.js";

export type ReverseAccessListResponse = {
  object: "list";
  modelId: string;
  data: Array<ReverseAccessEntry>;
};

/** @internal */
export const ReverseAccessListResponse$inboundSchema: z.ZodType<
  ReverseAccessListResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  model_id: z.string(),
  data: z.array(ReverseAccessEntry$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "model_id": "modelId",
  });
});
/** @internal */
export type ReverseAccessListResponse$Outbound = {
  object: "list";
  model_id: string;
  data: Array<ReverseAccessEntry$Outbound>;
};

/** @internal */
export const ReverseAccessListResponse$outboundSchema: z.ZodType<
  ReverseAccessListResponse$Outbound,
  z.ZodTypeDef,
  ReverseAccessListResponse
> = z.object({
  object: z.literal("list"),
  modelId: z.string(),
  data: z.array(ReverseAccessEntry$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    modelId: "model_id",
  });
});

export function reverseAccessListResponseToJSON(
  reverseAccessListResponse: ReverseAccessListResponse,
): string {
  return JSON.stringify(
    ReverseAccessListResponse$outboundSchema.parse(reverseAccessListResponse),
  );
}
export function reverseAccessListResponseFromJSON(
  jsonString: string,
): SafeParseResult<ReverseAccessListResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ReverseAccessListResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReverseAccessListResponse' from JSON`,
  );
}
